import { Spinner } from '@vmware-react/clarity/dist/spinner';
import React from 'react';
import './Workflow.css';

interface WorkflowProps {
  orientation: 'horizontal' | 'vertical';
  currentStep: number;
  overlay?: React.ReactElement<OverlayProps>;
  steps: React.ReactElement<{}>;
  body: React.ReactElement<BodyProps>;
  footer: React.ReactElement<{}>;
}

interface OverlayProps {
  spinnerText?: string;
  spinnerSize?: 'sm' | 'md' | 'lg';
}

interface BodyProps {
  children: Array<React.ReactElement<{}> | null>;
}

interface PagesProps {
  pages: Array<React.ReactElement<{}>>;
  currentStep: number;
}

export const Workflow: React.FC<WorkflowProps> = props => {
  const { currentStep, orientation, overlay, steps, footer, body } = props;

  const renderBody = () => {
    const pages: Array<React.ReactElement<{}>> = [];
    React.Children.forEach(body.props.children, child => {
      if (React.isValidElement(child)) {
        pages.push(child);
      }
    });
    return <WorkflowPages pages={pages} currentStep={currentStep} />;
  };

  if (orientation === 'horizontal') {
    return (
      <div className="crc-workflow crc-workflow-horizontal">
        <div className="crc-workflow-steps">{steps}</div>
        <div className="crc-workflow-body">{renderBody()}</div>
        <div className="crc-workflow-body-separator" />
        <div className="crc-workflow-footer">{footer}</div>
        {overlay && (
          <div className="crc-workflow-overlay-wrapper">{overlay}</div>
        )}
      </div>
    );
  } else {
    return (
      <div className="crc-workflow crc-workflow-vertical">
        <div className="crc-workflow-vertical-left-half">
          <div className="crc-workflow-steps">{steps}</div>
        </div>
        <div className="crc-workflow-vertical-right-half">
          <div className="crc-workflow-body">{renderBody()}</div>
          <div className="crc-workflow-body-separator" />
          <div className="crc-workflow-footer">{footer}</div>
        </div>
        {overlay && (
          <div className="crc-workflow-overlay-wrapper">{overlay}</div>
        )}
      </div>
    );
  }
};

export const WorkflowOverlay: React.FC<OverlayProps> = props => {
  const { spinnerSize = 'md', spinnerText } = props;
  return (
    <div className="crc-workflow-overlay">
      <div className="crc-workflow-overlay-spinner">
        <Spinner size={spinnerSize} />
        {spinnerText && (
          <span className="crc-workflow-overlay-spinner-text">
            {spinnerText}
          </span>
        )}
      </div>
      <div className="crc-workflow-overlay-mask" />
    </div>
  );
};

export const WorkFlowSteps: React.FC = props => {
  return <>{props.children}</>;
};

export const WorkFlowBody: React.FC<BodyProps> = props => {
  return <>{props.children}</>;
};

export const WorkFlowPage: React.FC = props => {
  return <>{props.children}</>;
};

export const WorkFlowFooter: React.FC = props => {
  return <>{props.children}</>;
};

const WorkflowPages: React.FC<PagesProps> = props => {
  const { pages, currentStep } = props;
  return (
    <div className="crc-workflow-pages">
      <div className="crc-workflow-page">{pages[currentStep]}</div>
    </div>
  );
};
